import type { VoidFunctionComponent } from 'react';

import { prettyMDY } from '../../../../shared/utils';
import Tooltip from '../Tooltip';

import FromNow from './FromNow';
import type { FromNowProps } from './FromNow';

/**
 * Wraps a FromNow, but provides a tooltip which will display the full
 * date, formatted via prettyMDY.
 *
 * @param {FromNowProps} props - FromNow props
 * @param {MomentInput} props.date - Could be a string or any valid moment input.
 * @param {number} [props.updateInterval] - If you wanted to customize how often this is updated.
 */
const FromNowWithTooltip: VoidFunctionComponent<FromNowProps> = ({ date }) => {
  //  This is mostly just for TS
  if (!date) {
    return null;
  }
  return (
    <Tooltip id={`from-now-tooltip-${date}`} tooltip={prettyMDY(date as string)}>
      <span className="inline-block">
        <FromNow date={date} />
      </span>
    </Tooltip>
  );
};

export default FromNowWithTooltip;
